/**
 * @generated SignedSource<<f9309a5246b377b04e6071ee882577e4>>
 * @relayHash 928e14504cea054d1244ccf4c022e350
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8b3b1e09c616007e089ee9ea7026d4922b2fadcf5dfa2547427274025af269d

import type { ConcreteRequest } from 'relay-runtime';
export type preloadContentSmartLinksForDraftQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksForDraftQuery$data = {
  readonly confluence_contentSmartLinksForDraft: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly product: string | null;
      readonly resolved: boolean;
      readonly resourceType: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
};
export type preloadContentSmartLinksForDraftQuery = {
  response: preloadContentSmartLinksForDraftQuery$data;
  variables: preloadContentSmartLinksForDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "confluence_contentSmartLinksForDraft",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "emojiTitle"
          },
          {
            "kind": "ScalarField",
            "name": "canView"
          },
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "resourceType"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "kind": "ScalarField",
            "name": "iconUrl"
          },
          {
            "kind": "ScalarField",
            "name": "resolved"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "928e14504cea054d1244ccf4c022e350",
    "id": "e8b3b1e09c616007e089ee9ea7026d4922b2fadcf5dfa2547427274025af269d",
    "metadata": {},
    "name": "preloadContentSmartLinksForDraftQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksForDraftQuery($contentId:ID!){confluence_contentSmartLinksForDraft(id:$contentId){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
  }
};
})();

(node as any).hash = "d08d65bd7c8823a600315f571b5567dc";

export default node;
